import { adminAPIService } from './index'

const route = 'product-promo-tags'

export default {
  getByStore(storeId) {
    return adminAPIService({
      url: `${route}/store-id/${storeId}`,
      method: 'get',
    })
  },
  getPromoTag(promoTagId) {
    return adminAPIService({
      url: `${route}/${promoTagId}`,
      method: 'get',
    })
  },
  updatePromoTag(promoTag, id) {
    const body = `json=${encodeURIComponent(JSON.stringify(promoTag))}`
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: body,
    })
  },
  createPromoTag(promoTag) {
    const body = `json=${encodeURIComponent(JSON.stringify(promoTag))}`
    return adminAPIService({
      url: route,
      method: 'post',
      data: body,
    })
  },
}
